export class EmailTemplateModel {
    public Id: number = 0;
    public RoutineName: string;
    public Description: string;
    public Subject: string;
    public Body: string;
    public SMSBody: string;
    public IsSystem: boolean;
    public LanguageId: number = 1;
}
export class SendSER4UrlModel {
    public Email: string;
    public Phone: string;
}




// WEBPACK FOOTER //
// ./src/app/models/EmailTemplateModel.ts